module.exports = __webpack_public_path__ + "static/media/Eros_EN.c2ebb8d0.png";